import React from 'react';
import { useTranslations } from 'next-intl';
import { observer, inject } from 'mobx-react';
import Link from '@/components/common/Link';
import { formatPrice, adjustColor } from '@/utils/misc';
import { calculateCartTotals } from '@/utils/cartTotals';

const MiniCartTotals = inject('wooCommerceStore', 'studioStore', 'generalSettingsStore')(observer(({ wooCommerceStore, studioStore, generalSettingsStore }) => {

  const t = useTranslations('Cart');
  const productDesign = studioStore.cart.product;
  const primaryColor = studioStore.settings.colors.primary_color;
  const hoverPrimaryColor = adjustColor(primaryColor, -30);

  const { total, totalSaved } = calculateCartTotals(wooCommerceStore.cart);
  const shippingCost = generalSettingsStore?.shippingMethods[0]?.cost;

  return (
    <div className={`mini-cart-totals p-4 mx-2 mb-2 bg-primary-light-studio ${productDesign?.border_radius}`}>
      {totalSaved > 0 && (
        <div className="flex justify-between items-center my-1 text-secondary-studio">
          <span className="text-lg font-semibold">{t('total_saved')}</span>
          <span className="text-lg font-semibold">{formatPrice(totalSaved)}</span>
        </div>
      )}
      {shippingCost > 0 && (
        <div className="flex justify-between items-center my-1">
          <span className="text-lg font-semibold">{t('shipping')}</span>
          <span className="text-lg font-semibold">{formatPrice(shippingCost)}</span>
        </div>
      )}
      {total >= generalSettingsStore.minOrder ? (
        <Link href="/checkout-start" onClick={() => wooCommerceStore.toggleCart()}>
          <button className="payment-button w-full mt-4 text-white font-bold py-2 px-4 rounded-lg transition duration-300" data-testid="proceed-to-checkout-button">
            <div className="flex justify-between items-center">
              <span className="text-lg font-semibold">{t('proceed_to_checkout')}</span>
              <span className="text-lg font-semibold">{formatPrice(Number(total) + Number(shippingCost))}</span>
            </div>
          </button>
        </Link>
      ) : (
        <>
          <button
            onClick={wooCommerceStore.toggleMinOrderModal}
            className="payment-button w-full mt-4 text-white font-bold py-2 px-4 rounded-lg transition duration-300"
            data-testid="proceed-to-checkout-button"
          >
            <div className="flex justify-between items-center">
              <span className="text-lg font-semibold">{t('proceed_to_checkout')}</span>
              <span className="text-lg font-semibold">{formatPrice(Number(total) + Number(shippingCost))}</span>
            </div>
          </button>
        </>
      )}
      <style jsx>{`
        .payment-button {
          background-color: ${primaryColor}
        }
        .payment-button:hover {
          background-color: ${hoverPrimaryColor};
        }
      `}</style>
    </div>
  );
}));

export default MiniCartTotals;